/*
 * @Author: 肖玲
 * @Date: 2023-02-17 15:04:35
 * @LastEditTime: 2023-02-17 15:05:52
 * @LastEditors: 肖玲
 * @Description: 
 * @FilePath: \p2ps_vip_web\src\router\learning-platform\learning-assessment-manage\modules\statisticalAnalysisRouter.js
 * 学习考核管理
 */
import learningPlatformRouter from './modules/learningPlatformRouter'
import statisticalAnalysisRouter from './modules/statisticalAnalysisRouter'
const learningAssessmentManageRouters = [].concat(learningPlatformRouter, statisticalAnalysisRouter)
export default learningAssessmentManageRouters